require('./province-form.scss')

module.exports = {
  template: require('./province-form.pug')()
  controller: require('./province-form.ctrl')
  bindings:
    province: '<'
    onSubmit: '&'
}
